// extracted by mini-css-extract-plugin
export var container = "SearchResults-module--container--f725c";
export var inputContainer = "SearchResults-module--inputContainer--aba0a";
export var noResultEmptyState = "SearchResults-module--noResultEmptyState--5d972";
export var pageTitle = "SearchResults-module--pageTitle--2a769";
export var resultsCountContainer = "SearchResults-module--resultsCountContainer--6f01e";
export var searchResults = "SearchResults-module--searchResults--7bd91";
export var wrapper = "SearchResults-module--wrapper--a1880";